import { FunctionComponent } from 'react';
import '../../../css/PublicAboutUsPage.css';

const Component05: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-five-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>Historia y Origen de VisiónDERRED</h2>
        <small>FONDEF · ANID</small>
      </div>
      <p className='public-about-us-page-text vdr-about-lead vdr-about-quote'>
        VisiónDERRED nace con la idea de transformar la gestión y análisis de redes eléctricas
        mediante el uso de tecnología de punta para incrementar la visibilidad de las redes, apoyar
        la planificación de redes informada e impulsar la integración de recursos energéticos
        distribuidos. Esta idea se convirtió en una postulación a un fondo FONDEF de ANID, la cual
        finalmente fue adjudicada el año 2024 y desde entonces el proyecto se encuentra en pleno
        desarrollo.
      </p>
    </div>
  );
};

export default Component05;
